import styled from "styled-components";
import { FooterNav } from "../../components/Footer/styles";
export const StyledModal = styled.section`
    padding: 0;
    margin: 0;
    width: 100%;
    height: 100%;
    display: flex;
 justify-content: flex-start;
    align-items: center;
    flex-flow: column;
    background-color: #fcffff;
    background: url("https://resources.swmc.com/images/yourtruehome/Rules-header.png")
      no-repeat;
    background-position: center top;
    background-size: 160%;
    @media only screen and (min-width: 320px) and (max-width: 575px) {
      margin-top: 5rem !important;
    }
    @font-face {
      font-family: poppins;
      font-weight: 300;
      src: url("https://d2b7dijo04ypct.cloudfront.net/events-templates/fonts/poppins-regular.woff2") format("otf");
      font-display: swap;
    }
    @font-face {
      font-family: poppins;
      font-weight: 400;
      src: url("https://d2b7dijo04ypct.cloudfront.net/events-templates/fonts/poppins-regular.woff2") format("otf");
      font-display: swap;
    }
    @font-face {
      font-family: poppins;
      font-weight: 600;
      src: url("https://d2b7dijo04ypct.cloudfront.net/events-templates/fonts/poppins-regular.woff2") format("otf");
      font-display: swap;
    }
    @font-face {
      font-family: poppins;
      font-weight: 700;
      src: url("https://d2b7dijo04ypct.cloudfront.net/events-templates/fonts/poppins-regular.woff2") format("otf");
      font-display: swap;
    }
    font-family: poppins;
    font-weight: 400;
    @media only screen and (min-width: 600px) {
      background-size: 160%;
    }
    @media only screen and (min-width: 800px) {
      background-size: 115%;
      background-size: 160%;
    }
    @media only screen and (min-width: 1000px) {
      background-size: 100%;
      background-size: 120%;
    }
  `,
  IconBox = styled.div`
    padding: 0;
    margin: 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    position: absolute;
    top: calc(5rem + 15px);
    right: 3px;

    @media only screen and (min-width: 600px) {
      position: absolute;
      flex-direction: row;
      top: calc(7rem);
      left: 3px;
    }
  `,
  RulesHeader = styled.header`
    padding: 0;
    margin: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin: 0;
    height: auto;
    padding: 1vw 0vw;
    @media (min-width: 1500px) {
      margin-top: 2rem;
    }
  `,
  HeaderText = styled.h1`
    padding: 0;
    margin: 0;
    font-weight: 600;
    line-height: 102px;
    text-align: center;
    color: #ffffff;
    width: 100%;
    white-space: nowrap;
    font-size: 40px;
    font-size: 6.68vw;
    @media only screen and (min-width: 600px) {
      margin-top: 75px;
      font-size: 45px;
    }
    @media only screen and (min-width: 1000px) {
      font-size: 50px;
    }
    @media only screen and (min-width: 1500px) {
      font-size: 3.4vw;
    }
  `,
  DisclaimerBox = styled.div`
    padding: 0;
    margin: 0;
    background: #ffffff;
    border: 3px solid #29a9e1;
    box-shadow: 0px 4px 94px rgba(0, 167, 217, 0.25);
    border-radius: 20px;
    width: calc(90% - 4rem);
    padding: 2vw;
    margin-top: -2rem;
    @media only screen and (min-width: 600px) {
      padding: 1rem;
      width: calc(90% - 4rem);
      margin-top: 0rem;
    }
    @media only screen and (min-width: 1000px) {
      padding: 0.5rem;
      width: calc(90% - 8rem);
      margin-top: 2rem;
    }
    @media (min-width: 1500px) {
      margin-top: 5rem;
    }
  `,
  Disclaimer = styled.p`
    padding: 0;
    margin: 0;
    font-weight: 600;
    line-height: 160%;
    text-align: center;
    color: #083f88;
    font-size: 3vw;
    @media only screen and (min-width: 600px) {
      font-size: 18px;
    }
    @media only screen and (min-width: 1000px) {
      font-size: 1.75vw;
    }
    @media only screen and (min-width: 1500px) {
      font-size: 1.5vw;
    }
  `,
  RuleBox = styled.div`
    padding: 0;
    margin: 0;
    width: 80%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    margin-left: 10%;
    &::after {
      margin-left: -11%;
      content: "";
      height: 3px;
      background: #00aae4;
      opacity: 20%;
      width: 112%;
      margin-top: 1.5vw;
    }
    @media only screen and (min-width: 600px) {
      margin-left: 5%;
    }
  `,
  Rule = styled.li`
    padding: 0;
    margin: 0;
    font-size: 5vw;
    position: relative;
    font-weight: 600;
    color: #083f88;
    @media only screen and (min-width: 600px) {
      font-size: 30px;
    }
    @media only screen and (min-width: 1000px) {
      font-size: 35px;
    }
    @media only screen and (min-width: 1500px) {
      font-size: 2.5vw;
    }
  `,
  RuleText = styled.p`
    padding: 0;
    margin: 0;
    padding: 0.5rem 0vw;
    font-weight: 400;
    font-size: 4vw;
    @media only screen and (min-width: 400px) {
      font-size: 3.5vw;
    }
    @media only screen and (min-width: 500px) {
      font-size: 3vw;
    }
    @media only screen and (min-width: 600px) {
      font-size: 18px;
    }
    @media only screen and (min-width: 1000px) {
      font-size: 1.5vw;
    }
  `,
  Row = styled.div`
    padding: 0;
    margin: 0;
    width: calc(100% - 2rem);
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1rem;
    color: black;
  `,
  Unordered = styled.ul`
    padding: 0;
    margin: 0;
    list-style-type: disc;
    list-style-position: inside;
    margin: 0 0 0 1rem;
    li {
      font-weight: 400;
      font-size: 2.75vw;
      @media only screen and (min-width: 600px) {
        font-size: 17px;
      }
      @media only screen and (min-width: 1000px) {
        font-size: 1.25vw;
      }
    }
  `,
  List = styled.ol`
    padding: 0;
    margin: 0;
    width: 100%;
    list-style: none;
    list-style-position: outside;
    counter-reset: li;
    margin-top: 3rem;

    ${Rule}::before {
      content: counter(li);
      color: #ffffff;
      background: linear-gradient(180deg, #29a9e1 0%, #245199 100%);
      border-radius: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 6.5vw;
      width: 1.25em;
      height: 1.25em;
      padding: 0.3em 0.1em 0.1em 0.1em;
      margin-left: -2em;
      margin-top: -0.05em;
      position: absolute;
      @media only screen and (min-width: 600px) {
        font-size: 40px;
        margin-top: -0.05em;
      }
      @media only screen and (min-width: 1000px) {
        font-size: 45px;
        margin-top: 0;
      }
      @media only screen and (min-width: 1500px) {
        font-size: 3.15vw;
      }
    }
    ${Row}:last-of-type {
      ${RuleBox}::after {
        display: none;
      }
    }
    ${Rule} {
      counter-increment: li;
    }
  `,
  BottomBorder = styled.div`
    margin: 0;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    flex-flow: column;
    align-items: flex-start;
    height: 3rem;
    background: #083f88;
    &::before {
      content: "";
      height: 1rem;
      width: 100%;
      background: #29a9e1;
    }
    @media only screen and (min-width: 320px) and (max-width: 991px){
    height: 8rem!important;
   }
  `,
  ProgressBox = styled.div`
    padding: 0;
    margin: 0;
    position: -webkit-sticky;
    position: sticky;
    align-self: flex-start;
    top: 5rem;
    z-index: 1;
    width: 100%;
    height: 8px;
    background: #ccc;
  `,
  ProgressBar = styled.div`
    padding: 0;
    margin: 0;
    height: 8px;
    background: #29a9e1;
    width: 0%;
  `,
  CopyrightBar = styled(FooterNav)`
    background: #083f88;
    margin: 0;
    border: 0;
    height: 100%;
    @media only screen and (min-width: 600px) {
      padding: 3px;
      width: calc(100% - 6px);
      justify-content: space-around;
    }
  `,
  CopyrightText = styled.p`
    color: #ffffff;
    font-size: 15px;
    width: 100%;
    font-weight: 100;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0rem 2rem 3rem 2rem;
    @media only screen and (min-width: 600px) {
      font-size: 1.5vw;
      padding: 0.1rem 3vw 0.1rem 3rem;
    }
    @media only screen and (min-width: 320px) and (max-width: 599px){
       padding: 0rem 2rem 5rem 2rem;
    }
    @media only screen and (min-width: 600px) and (max-width:991px){
      padding-bottom:2.5rem;
   }
    @media only screen and (min-width: 1000px) {
      font-size: 1vw;
    }
  `,
  SocialIcon = styled.img`
    padding: 0;
    margin: 0;
    height: 3vw;
    width: 3vw;
    @media only screen and (min-width: 600px) {
      height: 2vw;
      width: 2vw;
    }
    @media only screen and (min-width: 1000px) {
      height: 1.75rem;
      width: 1.75rem;
    }
  `,
  SocialPadding = styled.a`
    padding: 0;
    margin: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1vw;
    background: linear-gradient(180deg, #083f88 -5.1%, #00aae4 88.78%);
    border: 2px solid #29a9e1;
    box-sizing: border-box;
    border-radius: 50%;
    margin: 0.1rem 0.1rem;
    text-decoration: none;
    &:hover {
      background: linear-gradient(180deg, #00aae4 -5.1%, #083f88 88.78%);
    }
    @media only screen and (min-width: 600px) {
      margin: 0rem 0.15rem;
      padding: 1vw;
    }
    @media only screen and (min-width: 1000px) {
      margin: 0rem 0.25rem;
      padding: 1vw;
    }
  `;
